<template>
  <div class="card user-card">
    <div class="card-image">
      <figure class="image" v-bind:style="">
      </figure>
    </div>
    <div class="card-content">
      <div class="media">
        <div class="media-content">
          <p class="title is-5">{{user.name}}</p>
        </div>
      </div>
      <div class="content"> 
        <small>{{user.email}}</small>
      </div>
    </div>
    <footer class="card-footer">
        <a class="card-footer-item" @click="editUser">Editar</a>
        <a class="card-footer-item" @click="deleteUser">Apagar</a>
    </footer>
  </div>
</template>

<script>
  import Vue from 'vue'
  import DeleteUserCardModal from './UserDeleteModal'
  import EditUserCardModal from './UserEditModal'

  const CardEditModalComponent = Vue.extend(EditUserCardModal)
  const CardDeleteModalComponent = Vue.extend(DeleteUserCardModal)
  
export default {
  
    components: {
      CardDeleteModalComponent,
      CardEditModalComponent
    },

    props: {
      user: {}
    },

    data () {
      return {}
    },

    computed: {
    },

    methods: {
      editUser () {
        let openCardModal = (propsData = {}) => {
          return new CardEditModalComponent({
            el: document.createElement('div'),
            propsData
          })
        }

        openCardModal({
          title: 'Editar utilizador',
          userData: this.user
        })
      },
      deleteUser () {
        let openCardModal = (propsData = {}) => {
          return new CardDeleteModalComponent({
            el: document.createElement('div'),
            propsData
          })
        }

        openCardModal({
          title: 'Apagar Utlizador?',
          id: parseInt(this.user.id)
        })
      }
    }
}
</script>

<style lang="scss">
  .user-card.card {
    margin: 0 10px 10px 0;
  }
</style>


// WEBPACK FOOTER //
// UserCard.vue?5af925cd